import reducer from "./reducer";
export { default as digitalFolderSettings } from "./components/index";
export { default as digitalFolderSettingsReducerName } from "./constants";
export default reducer;
